import React, {useState, useEffect, useRef, useContext} from 'react';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Checkbox } from 'primereact/checkbox';

const COL_DISPLAY_INPUT = {
    Dobavljac:    'Dobavljač',
    Kolicina:     'Količina',
    JedinicnaCena:'Jedinična cena',
    DatumSipanja: 'Datum sipanja',
};
const PumpsInput = () => {
  /* Odgovor procedure dolazi kao NIZ redova, pa je poruka u prvom redu.
     Citanje sa samog niza daje undefined — zbog toga je odbijen unos ranije
     prolazio kao uspeh, a zapisa nije bilo. */
  const porukaIz = (data) => (Array.isArray(data) ? data?.[0]?.message : data?.message);
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdItem , setSelectedRowIdItem] = useState(null);
        const isSelected = (row) => String(getIdItem(row)) === String(selectedRowIdItem);
        
        const [pumpsOptions, setPumpsOptions] = useState([])
        const [dobavljacOptions, setDobavljacOptions] = useState([])

        const [datumOd, setDatumOd] = useState(null);
        const [datumDo, setDatumDo] = useState(null);
        const [sviUlazi, setUlazi] = useState(false);

        const [stanje, setStanje] = useState(null)
        const [izabran, setIzabran] = useState(false)
        const [idItem, setIdItem] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdItem = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

        const resetFilter = () => {
          setDatumOd(null)
          setDatumDo(null)
          setUlazi(false)
        }

         const [formData, setFormData] = useState({
            id_pumpa: null,
            datum: null,
            dobavljac: null,
            prevoznik: '',
            jedinicnaCena: null,
            zbir: null,
            kolicina: null,
            napomena: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali sipanje da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/GetLoad", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(porukaIz(data)){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: porukaIz(data),
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka sipanja!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormData({
        id_pumpa: apiData[0].id_pumpa || null,
        datum: apiData[0].datum ? new Date(apiData[0].datum) : null,
        dobavljac: apiData[0].dobavljac || null,
        prevoznik: apiData[0].prevoznik || '',
        jedinicnaCena: apiData[0].jedinicnaCena || null,
        zbir: apiData[0].jedinicnaCena * apiData[0].kolicina,
        kolicina: apiData[0].kolicina || null,
        napomena: apiData[0].napomena || ''
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  sve: sviUlazi
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/GetFuelAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setPumpsOptions(parsedData.PumpsDB)
                                setDobavljacOptions(parsedData.KlijentsDB)
                                setTableData(parsedData.PumpsRecordsDB)
                                setStanje(parsedData.Stanje)


                                 if (parsedData.PumpsRecordsDB && parsedData.PumpsRecordsDB.length > 0) {
                                                const columns = Object.keys(parsedData.PumpsRecordsDB[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: COL_DISPLAY_INPUT[key] || key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                const originalOrder = Object.keys(parsedData.PumpsRecordsDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted, sviUlazi])



const resetData = ()=> {
        setFormData({
            id_pumpa: null,
            datum: null,
            dobavljac: null,
            prevoznik: '',
            jedinicnaCena: null,
            zbir: null,
            kolicina: null,
            napomena: ''
        });
}
const handleDeleteItem = () => {
       
            confirmDialog({
            message: "Želite obrisati sipanje?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
 
  if (idItem) {
    setFormSubmitted(true)
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idItem
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/DeleteLoad", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešno pasiviziranje sipanja!",
                life: 3000,
                });
                resetData()
                resetFilter()
                setIdItem(null)
                setFormSubmitted(false)
                setSelectedRowIdItem(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali sipanje za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValue = Object.values(formData).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formData,
                        datum: toUtcIso(formData.datum),
                        };

                  if(izabran && idItem){
                 if(hasAnyValue){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idItem),
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/UpdateLoad", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima sipanja.' && data[0].message != 'Nedostaje id za UPDATE.' 
                                        && data[0].message != 'Zapis nije pronađen ili nije aktivan.' && data[0].message != 'Izmena nije moguća: postoji drugi identičan aktivan unos sipanja.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                return
                               }

                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka sipanja!",
                                life: 3000,
                                });
                                
                                resetFilter()
                                setFormSubmitted(false)
                                setIdItem(null)
                                setSelectedRowIdItem(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke sipanja!",
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValue){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formData: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/InsertLoad", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                  if(porukaIz(data)) {
                                        if(porukaIz(data) != 'Već postoji aktivan magacin sa istim nazivom i tipom.' && porukaIz(data) != 'Uspešan unos magacina!'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: porukaIz(data),
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  
                                  resetFilter()
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka sipanja!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke magacina za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name in formData) {
            if(name == 'jedinicnaCena' && formData.kolicina)
            setFormData(prev => ({ ...prev, ["zbir"]: value * formData.kolicina }));

            if(name == 'kolicina' && formData.jedinicnaCena)
            setFormData(prev => ({ ...prev, ["zbir"]: value * formData.jedinicnaCena }));

        setFormData(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sipanja');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Sipanja - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">              
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              {selectedRowIdItem && <Button type="button" style={{marginLeft:'5px'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteItem} data-pr-tooltip="Print" />}             
              </div>
                                         <div style={{minHeight:'100%', display:'flex', justifyContent: 'center', alignItems:'center',minWidth: '5%'}}>
                            <Checkbox 
                            id="sviUlazi" 
                            name="sviUlazi" 
                            checked={sviUlazi} 
                            onChange={(e)=>setUlazi(e.target.checked)} 
                            tooltip="SVI ULAZI"
                            tooltipOptions={{ position: 'top' }}
                          />
                          
                          <Calendar
                            value={datumOd}
                            onChange={(e) => setDatumOd(e.value)}
                            placeholder="Datum OD"
                            dateFormat="dd.mm.yy"
                            mask="99.99.9999"
                            style={{marginRight:'1%', maxWidth:'20%'}}
                          />
                
                          <Calendar
                            value={datumDo}
                            onChange={(e) => setDatumDo(e.value)}
                            placeholder="Datum DO"
                            dateFormat="dd.mm.yy"
                            mask="99.99.9999"
                            style={{marginRight:'1%', maxWidth:'20%'}}
                          />
                                              <input
                                                style={{width:'30%'}}
                                                type="search"
                                                onInput={(e) => setGlobalFilter(e.target.value)}
                                                placeholder={t('nova.phPretraga')}
                                                className="p-inputtext p-component"
                                              /></div>
          </div>
      );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseItem = (rowData) => {
        const id = getIdItem(rowData);

        setSelectedRowIdItem((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdItem(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdItem(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
              />
            
        </div>
      );
    };

    const filteredData = tableData?.filter(item => {
      const datumString = item["DatumSipanja"];

      if (!datumString) return false; // zaštita

      // Pretvori "10.09.2025" → Date objekt
      const [day, month, year] = datumString.split(".");
      const datum = new Date(`${year}-${month}-${day}`);

      if (datumOd && datum < datumOd) return false;
      if (datumDo && datum > datumDo) return false;

      return true;
    });

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

        <ConfirmDialog />
            <div className='col-12 md:col-6'>
                          <div className='blagajnaDashboard dnevniceDashboard'>
                             <Card>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="gridLicni">
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_pumpa">{t('magacin.pumpa')}:</label>
                                            <CustomDropdown
                                                 id="id_pumpa" 
                                                 name="id_pumpa" 
                                                 value={formData.id_pumpa} 
                                                 options={pumpsOptions || []}
                                                 placeholder={t('magacin.phPumpu')}
                                                 required
                                                invalid={invalidControl(formData.id_pumpa)}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                               <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                     <label htmlFor="datum">{t('magacin.datumSipanja')}:</label>
                                            <Calendar 
                                                required 
                                                mask="99.99.9999" 
                                                invalid={invalidControl(formData.datum)} 
                                                id="datum" 
                                                name="datum" 
                                                value={formData.datum} 
                                                onChange={handleChange} 
                                                showIcon 
                                                dateFormat="dd.mm.yy" 
                                                />
                                    </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="dobavljac">Dobavljač:</label>
                                            <CustomDropdown
                                                 id="dobavljac" 
                                                 name="dobavljac" 
                                                 value={formData.dobavljac} 
                                                 options={dobavljacOptions || []}
                                                 placeholder="Izaberi dobavljača"
                                                 required
                                                invalid={invalidControl(formData.dobavljac)}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                    <label htmlFor="prevoznik">Prevoznik:</label>
                                    <InputText
                                    id="prevoznik" 
                                    name="prevoznik" 
                                    value={formData.prevoznik} 
                                    onChange={handleChange} 
                                    />
                                </div>
                            <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                    <label htmlFor="jedinicnaCena">Jedinična cena:</label>
                                     <InputNumber
                                                                        id="jedinicnaCena" 
                                                                        name="jedinicnaCena" 
                                                                        value={formData.jedinicnaCena} 
                                                                        required
                                                                        invalid={invalidControl(formData.jedinicnaCena)}
                                                                        onValueChange={handleChange} 
                                                                        minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                               <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                    <label htmlFor="kolicina">{t('nova.kolicina')}:</label>
                                     <InputNumber
                                                                        id="kolicina" 
                                                                        name="kolicina" 
                                                                        value={formData.kolicina} 
                                                                        required
                                                                        invalid={invalidControl(formData.kolicina)}
                                                                        onValueChange={handleChange} 
                                                                        minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                    <label htmlFor="zbir">{t('magacin.ukupnoIznos')}:</label>
                                     <InputNumber
                                                                        id="zbir" 
                                                                        name="zbir" 
                                                                        value={formData.zbir} 
                                                                        required
                                                                        invalid={invalidControl(formData.zbir)}
                                                                        onValueChange={handleChange} 
                                                                        disabled
                                                                        minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                    <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                    <InputText
                                    id="napomena" 
                                    name="napomena" 
                                    value={formData.napomena} 
                                    onChange={handleChange} 
                                    />
                                </div>
                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                              {stanje && stanje.length > 0 && (
                                    <>
                                        <h4 style={{marginTop:'1%'}}>{t('magacin.trenutnoStanjePumpe')}</h4>
                                        <div className='col-12 md:col-6'>
                                            {stanje.map((item, index) => (
                                                <div key={index} className="mb-2" style={{fontSize: '20px'}}>
                                                    {index + 1}. <b>{item.Naziv}</b>: {item.Stanje} [lit]
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                    )}         
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={filteredData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplate(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                                              
       </div>
)
}

export default PumpsInput;